import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { router } from './router'
import { queryClient } from './lib/api'

if (window.location.hash.startsWith('#/')) {
	const path = window.location.hash.slice(1)
	window.history.replaceState(null, '', path)
}

const root = createRoot(document.getElementById('root')!)
root.render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>
)
